import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomLandingModule } from '../../custom-landing.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { I18nModule } from '@spartacus/core';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-inspection-screening-pop-up',
   imports: [
      CustomLandingModule,
      CommonModule,
      FormsModule,
      NgSelectModule,
      I18nModule,
      SharedModule,
    ],
  templateUrl: './inspection-screening-pop-up.component.html',
  styleUrls: ['./inspection-screening-pop-up.component.scss']
})
export class InspectionScreeningPopUpComponent {
 @Input() userType: string;
  @Input() cargoAgentMembers: any[] = [];
  @Input() agentName: string;
constructor(public activeModal: NgbActiveModal){

}
  ngOnInit() {
  }

}
